module.exports = __webpack_public_path__ + "img/iikoBiz-48.8af734e3.jpg";